module.exports = require("./tzm-MA.js");